<div fxLayout="row wrap" fxLayoutAlign="space-around start">
  <mat-card fxFlex="40%">
    <mat-card-header>Client</mat-card-header>
    <mat-card-content>
      <ul>
        <li>Commit: {{ clientCommit }}</li>
        <li>Build: {{ clientBuild }}</li>
        <li>Release: {{ clientRelease }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card fxFlex="40%">
    <mat-card-header>Main Api</mat-card-header>
    <mat-card-content>
      <ul>
        <li>Commit: {{ mainCommit }}</li>
        <li>Build: {{ mainBuild }}</li>
        <li>Release: {{ mainRelease }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card fxFlex="40%">
    <mat-card-header>Data Api</mat-card-header>
    <mat-card-content>
      <ul>
        <li>Commit: {{ dataCommit }}</li>
        <li>Build: {{ dataBuild }}</li>
        <li>Release: {{ dataRelease }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card fxFlex="40%">
    <mat-card-header>Detection Api</mat-card-header>
    <mat-card-content>
      <ul>
        <li>Commit: {{ detCommit }}</li>
        <li>Build: {{ detBuild }}</li>
        <li>Release: {{ detRelease }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
</div>
